import React, { useEffect, useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  TextField,
  MenuItem,
  Skeleton,
  Select,
  FormControl,
  IconButton,
} from '@mui/material';
import PdfIcon from 'assets/images/pdficon.png';
import Loading from 'assets/images/loading.png';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { ImageIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { getApiCall } from 'api/apiService';
import {
  UPLOAD_FILE_MANAGER,
  API_URL,
  DOCUMENT_TYPE_LIST,
} from 'constant/app.config';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Swal from 'sweetalert2';
import { postApiCall } from 'api/apiService';
import RedoWarning from 'modules/private/BuyerSolicitor/RedoWarning';
const FilesUploadPopup = ({
  open,
  handleClose,
  documentType,
  propertyId,
  buyerId,
  userType,
  isDialog,
  onUploadSuccess,
  onUploadNavigate,
  shouldPrefill,
  isFileView,
  selectedeta,
  statustext,
  address,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState(null);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [linkValue, setLinkValue] = useState('');
  const [openRedoWarning, setOpenRedoWarning] = useState(false);
  // const isLocked = shouldPrefill;
  const baseType = documentType?.split('-')[0].trim().toLowerCase();

  const isSpecialCase =
    baseType === 'contract of sale' || baseType === 'approved amendments';

  const isLocked =
    userType === 'buyer' ? shouldPrefill && !isSpecialCase : shouldPrefill;

  const getFilteredDocumentTypes = () => {
    const normalize = (str) => str?.split('-')[0]?.trim()?.toLowerCase();
    if (isDialog) {
      return documentTypes.filter(
        (item) => normalize(item.documentType) === 'contract of sale'
      );
    }
    if (userType !== 'buyer') return documentTypes;

    if (!documentType) return documentTypes;

    const baseType = normalize(documentType);

    if (baseType === 'contract of sale') {
      return documentTypes.filter((item) => {
        const type = normalize(item.documentType);
        return type === 'contract of sale' || type === 'approved amendments';
      });
    }

    if (baseType === 'approved amendments') {
      return documentTypes.filter((item) => {
        const type = normalize(item.documentType);
        return type === 'approved amendments' || type === 'contract of sale';
      });
    }

    return documentTypes;
  };
  const selectedDoc = documentTypes.find(
    (item) => item.documentId === selectedDocumentType
  );
  const fileInputRef = React.useRef(null);
  const isLinkType =
    selectedDoc?.documentType?.toLowerCase()?.includes('link') || false;

  const normalizeDocType = (str) => {
    if (!str) return '';

    return str.split('-')[0].trim().toLowerCase();
  };
  const isUploadDisabled =
    (!isLinkType && !selectedFile) ||
    (isLinkType && !linkValue?.trim()) ||
    !description?.trim() ||
    !selectedDocumentType ||
    (userType?.toLowerCase() === 'vendor solicitor' &&
      normalizeDocType(selectedDoc?.documentType) === 's66w certificate');

  const handleUpload = async () => {
    try {
      if (!isLinkType && !selectedFile) return;
      if (isLinkType && !linkValue?.trim()) return;
      const selectedDoc = documentTypes.find(
        (item) => item.documentId === selectedDocumentType
      );

      const selectedTypeName = selectedDoc?.documentType?.trim();

      const isSameType =
        normalizeDocType(selectedTypeName) == normalizeDocType(documentType);

      setApiLoading(true);

      const formData = new FormData();

      if (isLinkType) {
        formData.append('file', linkValue);
      } else {
        formData.append('file', selectedFile);
      }
      formData.append('fileType', selectedDoc?.documentType?.trim() || '');
      formData.append('fileTypeCode', selectedDoc?.documentTypeCode || '');
      formData.append('propertyId', propertyId);
      // formData.append('buyerId', isDialog && buyerId ? buyerId : 0);
      formData.append(
        'buyerId',
        isDialog && buyerId ? buyerId : isFileView ? buyerId : 0
      );
      formData.append('userType', userType);
      formData.append('description', description.trim());

      const response = await postApiCall(UPLOAD_FILE_MANAGER, formData);
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      if (response?.data?.status === 1) {
        handleClose();
        const result = await Swal.fire({
          title: response?.data?.heading || 'Success',
          text: response?.data?.message || 'File uploaded successfully',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });

        if (result.isConfirmed) {
          if (onUploadSuccess) {
            onUploadSuccess();
          }

          if (onUploadNavigate) {
            onUploadNavigate(isSameType);
          }

          handleClose();
          resetStates();
        }
      } else {
        await Swal.fire({
          title: response?.data?.heading || 'Error',
          text: response?.data?.message || 'Upload failed',
          icon: 'error',
          confirmButtonText: 'Close',
          confirmButtonColor: '#4CA4D6',
        });
        resetStates();
        handleClose();
      }
    } catch (error) {
      console.error('UPLOAD ERROR', error);
    } finally {
      setApiLoading(false);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setError('');
    setSelectedFile(null);

    if (file.type !== 'application/pdf') {
      setError('Only PDF files are allowed');
      return;
    }

    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      setError('File size should not exceed 15MB');
      return;
    }

    setLoading(true);

    setTimeout(() => {
      setSelectedFile(file);
      setLoading(false);
    }, 800);
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const file = acceptedFiles[0];

      if (file.type !== 'application/pdf') {
        setError('Only PDF files are allowed');
        return;
      }

      const maxSize = 15 * 1024 * 1024;
      if (file.size > maxSize) {
        setError('File size should not exceed 15MB');
        return;
      }

      setError('');
      setLoading(true);
      setTimeout(() => {
        setSelectedFile(file);
        setLoading(false);
      }, 800);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'application/pdf': [] },
    multiple: false,
    noClick: true, // we handle click separately or let the child handle it
  });
  useEffect(() => {
    fetchDocumentTypes();
  }, []);
  useEffect(() => {
    if (isLinkType) {
      setSelectedFile(null);
    } else {
      setLinkValue('');
    }
  }, [selectedDocumentType]);
  const fetchDocumentTypes = async () => {
    try {
      const response = await getApiCall(DOCUMENT_TYPE_LIST, {
        userType,
      });
      if (response?.data?.status === 1) {
        const list = response?.data?.documentType || [];

        setDocumentTypes(list);
      }
    } catch (error) {
      console.error('DOCUMENT TYPE LIST ERROR', error);
    }
  };
  const resetStates = () => {
    setSelectedFile(null);
    setDescription('');
    setSelectedDocumentType(null);
    setError('');
    setLoading(false);
    setLinkValue('');
  };

  useEffect(() => {
    if (!open) return;

    if (!shouldPrefill) {
      setSelectedDocumentType(null);
      return;
    }
    if (documentType && documentTypes.length > 0) {
      const normalizeDocType = (str) => str?.split('-')[0].trim().toLowerCase();

      const matched = documentTypes.find(
        (item) =>
          normalizeDocType(item.documentType) == normalizeDocType(documentType)
      );

      if (matched) {
        setSelectedDocumentType(matched.documentId);
      }
    }
  }, [open, documentType, documentTypes, shouldPrefill]);

  const getRedoWarningDetails = () => {
    const selectedDocType = selectedDoc?.documentType?.trim();

    if (selectedDocType === 'Contract Of Sale') {
      return {
        heading: 'Redo Contract',
        message:
          'The Contract has already been signed. Creating this document will supersede all previous versions including signed documents.',
      };
    } else if (selectedDocType === 's66W Certificate') {
      return {
        heading: 'Redo s66W',
        message:
          'The s66W has already been signed. Creating this document will supersede all previous versions including signed documents.',
      };
    }

    return null;
  };
  const requiresRedoWarning = () => {
    const selectedDocType = selectedDoc?.documentType?.trim();
    if (selectedDocType === 'Contract Of Sale') {
      const isContractCompleted =
        (selectedeta === 'Contract' && statustext === 'Completed') ||
        (selectedeta?.includes('Contract') &&
          statustext?.includes('Completed')) ||
        (statustext === 'Completed / Completed' &&
          selectedDocType === 'Contract Of Sale');

      return isContractCompleted;
    }
    if (selectedDocType === 's66W Certificate') {
      const is66WCompleted =
        (selectedeta === '66W' && statustext === 'Completed') ||
        statustext === 'Completed / Completed' ||
        (statustext?.includes('Completed') &&
          selectedDocType === 's66W Certificate');

      return is66WCompleted;
    }

    return false;
  };

  const handleConfirmClick = () => {
    if (requiresRedoWarning() && redoDetails) {
      setOpenRedoWarning(true);
    } else {
      handleUpload();
    }
  };

  const isSolicitor =
    userType === 'Buyer Solicitor' || userType === 'Vendor Solicitor';

  const handleUploadAction = () => {
    if (isSolicitor) {
      handleConfirmClick();
    } else {
      handleUpload();
    }
  };

  const redoDetails = getRedoWarningDetails();

  return (
    <>
      <Dialog
        open={open}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '10px',
            px: 3,
            py: 3,
            boxShadow: '0px 8px 30px rgba(0,0,0,0.15)',
            fontFamily: 'Poppins, sans-serif',
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <Box mb={3} display="flex" flexDirection="column" alignItems="center">
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontWeight: 600,
                fontSize: '14px',
                lineHeight: '20px',
              }}
            >
              Upload New Version
            </Typography>
          </Box>

          <Box mt={3} display="flex" flexDirection="column" gap={2}>
            <Box display="flex" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={1} minWidth="140px">
                <ImageIcon />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    color: '#6B7280',
                  }}
                >
                  Document Type <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Box>

              <FormControl fullWidth size="small">
                {isLocked ? (
                  <TextField
                    value={
                      documentTypes.find(
                        (item) => item.documentId === selectedDocumentType
                      )?.documentType || ''
                    }
                    fullWidth
                    size="small"
                    InputProps={{
                      readOnly: true,
                      sx: { fontFamily: 'Poppins' },
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        padding: '8px 12px',
                      },
                    }}
                  />
                ) : (
                  <Select
                    value={selectedDocumentType || ''}
                    onChange={(e) => setSelectedDocumentType(e.target.value)}
                    displayEmpty
                    sx={{
                      fontFamily: 'Poppins',
                      '& .MuiSelect-select': {
                        fontFamily: 'Poppins',
                        fontSize: '12px',
                        '& .MuiSelect-select': {
                          fontFamily: 'Poppins',
                          fontSize: '12px',
                          padding: '8px 12px',
                        },
                      },
                    }}
                  >
                    <MenuItem
                      value=""
                      disabled
                      sx={{ fontFamily: 'Poppins', fontSize: '12px' }}
                    >
                      Select Document Type
                    </MenuItem>
                    {getFilteredDocumentTypes().map((item) => (
                      <MenuItem
                        key={item.documentId}
                        value={item.documentId}
                        disabled={
                          userType?.toLowerCase() === 'vendor solicitor' &&
                          normalizeDocType(item.documentType) ===
                            's66w certificate'
                        }
                        sx={{ fontFamily: 'Poppins', fontSize: '12px' }}
                      >
                        {item.documentType}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Box display="flex" alignItems="center" gap={1} minWidth="140px">
                <DescriptionOutlinedIcon sx={{ color: '#9CA3AF' }} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    color: '#6B7280',
                  }}
                >
                  Description <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Box>

              <TextField
                fullWidth
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Add description"
                size="small"
                variant="outlined"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                    backgroundColor: '#fff',
                    height: '36px',
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    fontWeight: 400,
                  },
                  '& .MuiInputBase-input': {
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                    fontWeight: 400,
                  },
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              width: '80%',
              margin: '0 auto',
              display: 'flex',
              mt: 3,
              flexDirection: 'column',
              alignItems: 'center',
              minHeight: '120px',
              justifyContent: 'center',
            }}
          >
            <input
              type="file"
              hidden
              id="fileUpload"
              accept="application/pdf"
              ref={fileInputRef}
              onChange={handleFileChange}
            />

            {isLinkType ? (
              <TextField
                fullWidth
                value={linkValue}
                onChange={(e) => setLinkValue(e.target.value)}
                placeholder="Enter document link"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '6px',
                    height: '36px',
                    fontFamily: 'Poppins',
                    fontSize: '12px',
                  },
                }}
              />
            ) : (
              <>
                {!selectedFile ? (
                  <Box
                    {...getRootProps()}
                    onClick={() =>
                      document.getElementById('fileUpload').click()
                    }
                    sx={{
                      border: isDragActive
                        ? '2px solid #8E6BE8'
                        : '2px dashed #8E6BE8',
                      borderRadius: '8px',
                      height: '140px',
                      width: '60%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: isDragActive ? '#EEEBFF' : '#F6F2FF',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <input {...getInputProps()} />
                    {loading ? (
                      <>
                        <Skeleton variant="circular" width={30} height={30} />
                        <Skeleton variant="text" width={80} />
                      </>
                    ) : (
                      <>
                        <AddCircleOutlineIcon
                          sx={{ fontSize: 32, color: '#8E6BE8' }}
                        />
                        <Typography
                          sx={{
                            fontSize: '12px',
                            color: '#8E6BE8',
                            fontFamily: 'Poppins',
                          }}
                        >
                          Upload or Drag here
                        </Typography>
                      </>
                    )}
                  </Box>
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <img src={PdfIcon} alt="pdf" style={{ width: 130 }} />

                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          textAlign: 'center',
                          fontSize: '12px',
                          lineHeight: '1.2',
                          maxWidth: '100%',
                          wordBreak: 'break-word',
                        }}
                      >
                        {selectedFile.name}
                      </Typography>
                      <IconButton
                        disabled={apiLoading}
                        onClick={() => {
                          setSelectedFile(null);
                          setError('');

                          if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                          }
                        }}
                      >
                        <DeleteOutlineOutlinedIcon
                          sx={{
                            fontSize: 18,
                            cursor: 'pointer',
                            color: '#8E6BE8',
                          }}
                        />
                      </IconButton>
                    </Box>
                  </Box>
                )}
              </>
            )}
            {error && (
              <Typography sx={{ color: 'red', fontSize: '11px', mt: 1 }}>
                {error}
              </Typography>
            )}
          </Box>

          <Box
            mt={3}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={2}
            width="100%"
          >
            <Button
              onClick={() => {
                resetStates();
                handleClose();
              }}
              disabled={apiLoading}
              variant="outlined"
              sx={{
                fontFamily: 'Poppins',
                fontSize: '12px',
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: '6px',
                height: '36px',
                px: 3,
                minWidth: '120px',
                color: '#6B7280',
                borderColor: '#E5E7EB',
                backgroundColor: '#F3F4F6',
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleUploadAction}
              disabled={isUploadDisabled || apiLoading}
              sx={{
                fontFamily: 'Poppins',
                fontSize: '12px',
                fontWeight: 500,
                textTransform: 'none',
                borderRadius: '6px',
                height: '36px',
                px: 3,
                minWidth: '120px',
                backgroundColor: '#4CA4D6',
                boxShadow: 'none',

                '&:hover': {
                  backgroundColor: '#3a8bb8',
                },

                '&.Mui-disabled': {
                  backgroundColor: '#BFDDF0',
                  color: '#FFFFFF',
                  opacity: 1,
                },
              }}
            >
              Confirm Upload
            </Button>
            {apiLoading && (
              <img
                alt="Loading"
                src={Loading}
                className="loaderImage"
                style={{
                  height: '25px',
                  width: '25px',
                  marginRight: '8px',
                }}
              />
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {openRedoWarning && redoDetails && (
        <RedoWarning
          open={openRedoWarning}
          onClose={() => setOpenRedoWarning(false)}
          address={address}
          heading={redoDetails.heading}
          message={redoDetails.message}
          onConfirm={() => {
            setOpenRedoWarning(false);
            handleUpload();
          }}
          onCancel={() => {
            setOpenRedoWarning(false);
          }}
        />
      )}
    </>
  );
};

export default FilesUploadPopup;
